/* tslint:disable */
/* eslint-disable */
/**
 * Megasense data portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PollutantPenalty,
    PollutantPenaltyFromJSON,
    PollutantPenaltyFromJSONTyped,
    PollutantPenaltyToJSON,
} from './';

/**
 * 
 * @export
 * @interface MedicalCondition
 */
export interface MedicalCondition {
    /**
     * 
     * @type {string}
     * @memberof MedicalCondition
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MedicalCondition
     */
    conditionName: string;
    /**
     * 
     * @type {boolean}
     * @memberof MedicalCondition
     */
    conditionApproved: boolean;
    /**
     * 
     * @type {Array<PollutantPenalty>}
     * @memberof MedicalCondition
     */
    conditionPenalties?: Array<PollutantPenalty>;
}

export function MedicalConditionFromJSON(json: any): MedicalCondition {
    return MedicalConditionFromJSONTyped(json, false);
}

export function MedicalConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'conditionName': json['conditionName'],
        'conditionApproved': json['conditionApproved'],
        'conditionPenalties': !exists(json, 'conditionPenalties') ? undefined : ((json['conditionPenalties'] as Array<any>).map(PollutantPenaltyFromJSON)),
    };
}

export function MedicalConditionToJSON(value?: MedicalCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'conditionName': value.conditionName,
        'conditionApproved': value.conditionApproved,
        'conditionPenalties': value.conditionPenalties === undefined ? undefined : ((value.conditionPenalties as Array<any>).map(PollutantPenaltyToJSON)),
    };
}


